import { PayloadAction, createSelector } from '@reduxjs/toolkit';
import { DetailsDrawerReducerState } from './types';
import { createExtendedSlice } from 'src/store/createExtendedSlice';
import { initialState } from './utils';
import { RootState } from 'src/store';

const sliceName = 'detailsDrawer';

// =============================
// ------- Slice ----------
// =============================
export const detailsDrawerSlice = createExtendedSlice({
  name: sliceName,
  initialState,
  reducers: {
    // ---- Internal ---
    detailsDrawerInit: (
      state,
      { payload }: PayloadAction<DetailsDrawerReducerState>,
    ) => {
      return payload;
    },
  },
});

// =============================
// ------- selectors ----------
// =============================
export const getDetailsDrawerType = (state: RootState) =>
  state.detailsDrawer.type;

export const getDetailsDrawerIsOpen = createSelector(
  getDetailsDrawerType,
  (type) => Boolean(type),
);

// =============================
// ------- Exports ----------
// =============================

export const { detailsDrawerInit } = detailsDrawerSlice.actions;

export default detailsDrawerSlice.reducer;
